import { render, staticRenderFns } from "./dainban.vue?vue&type=template&id=63ba9813&scoped=true&"
import script from "./dainban.vue?vue&type=script&lang=js&"
export * from "./dainban.vue?vue&type=script&lang=js&"
import style0 from "./dainban.vue?vue&type=style&index=0&id=63ba9813&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ba9813",
  null
  
)

export default component.exports